/*global angular*/
/*global _*/

angular.module('clinkManager')

.filter( 'type', function() {
    return function( clinks, type ) {
        var ret = _.filter( clinks, function( clink ) {
        	// Look for non-status types first.
        	if ( "unhealthy" === type ) {
        	    if ( clink.status === "ACTIVE" && clink.health !== "Green" ) {
        	    	return true;
        	    }	
        	    return false;
        	}
        	else if ( "needs_cleanup" === type ) {
        		// TODO: This is temporary.
        	    if ( clink.status === "ACTIVE" && clink.stats.clicks === 0 && clink.stats.installs === 0 ) {
        	    	return true;
        	    }
        	    return false;
        	}
        	else if ( type.indexOf( "+" ) >= 0 ) {
        		var statuses = type.split( '+' );
        		for ( var i = 0; i < statuses.length; i++ ) {
        			if ( clink.status === statuses[i].toUpperCase() ) {
        				return true;
        			}
        		}
        		return false;
        	}
        	else {
	        	if ( clink.status === type.toUpperCase() ) {
	        		return true;
	        	} 
        		return false;
        	}
        });
        return ret;
    };
})

.filter('status', function() {
  return function(clinks,status) {
  	status = status.toUpperCase();
    var ret = _.filter( clinks, function( clink ) {
    	if(clink.status === status) {
    		return true;
    	} else {
    		return false;
    	}
    });
    return ret;
  };
})

.filter('clink_search', function() {
	return function(clinks,term) {
		if( term ) {
			term = term.toLowerCase();
		}

		var ret = _.filter( clinks, function( clink ) {
			var hasTerm      = term;
			var appIDMatch   = clink.app_id.toLowerCase().indexOf(term)   !== -1;
			var clinkIDMatch = clink.clink_id.toLowerCase().indexOf(term) !== -1;
			var appNameMatch = clink.app_name ? clink.app_name.toLowerCase().indexOf(term) !== -1 : false;
			
			if( !hasTerm || appIDMatch || clinkIDMatch || appNameMatch ) {
				return true;
			} else {
				return false;
			}
		});
		return ret;
	};
})

.filter('publisher', function() {
	return function(clinks,publisher) {
		var ret = _.filter( clinks, function( clink ) {
			var noPublisherFilter = !publisher || publisher === "All";
			var pubMatch = !noPublisherFilter ? (clink.pub_id === publisher) : false;
			var all = !noPublisherFilter ? (publisher === "All") : false;

			if( noPublisherFilter || pubMatch || all ) {
				return true;
			} else {
				return false;
			}
		});
		return ret;
	};
})

.filter('min_payout', function() {
	return function(camps,min) {
		var ret = _.filter( camps, function( camp ) {
			return camp.payout >= min;
		});
		return ret;
	};
})

.filter('has_country', function() {
	return function(camps,tags) {
		var ret = _.filter( camps, function( camp ) {
			if( !tags || tags.length === 0 ) return true;
			
			var tgs = _.map( tags, function( tag ) {
				return tag.text;
			});

			var sect = _.intersection( camp.countries.split(','), tgs );
			if( sect && sect.length > 0 ) {
				return true;
			} else {
				return false;
			}
		});

		return ret;
	};
})

.filter( 'statusOnly', function() {
	  return function( status ) {
		  if ( status ) {
			  return status.split( ' ' )[0];
		  }
		  return status;
	  };
} )

;


